klaviyo.init({
    account: 'VwRtRs',
    platform: 'shopify',
    list: 'VY7jX6',
    collection_urls: ['/collections/'],
  });
  klaviyo.enable('backinstock', {
    trigger: {
      collection_page_class: 'btn',
      collection_page_text: window.klaviyo_bis.collection_page_text,
      product_page_text: window.klaviyo_bis.product_page_text,
      product_page_class: 'btn',
      product_page_text_align: 'center',
      product_page_margin: '0px',
      replace_anchor: false,
    },
    modal: {
      headline: '{product_name}',
      subscribe_checked: true,
      newsletter_subscribe_label: window.klaviyo_bis.newsletter_subscribe_label,
      body_content: window.klaviyo_bis.body_content,
      email_field_label: window.klaviyo_bis.email_field_label,
      button_label: window.klaviyo_bis.button_label,
      subscription_success_label: window.klaviyo_bis.subscription_success_label,
      footer_content: window.klaviyo_bis.footer_content,
      drop_background_color: '#000',
      background_color: '#fff',
      text_color: '#222',
      button_text_color: '#fff',
      button_background_color: '#000000',
      close_button_color: '#ccc',
      error_background_color: '#fcd6d7',
      error_text_color: '#C72E2F',
      success_background_color: '#d3efcd',
      success_text_color: '#1B9500',
      font_family: '"Sofia","Helvetica","Helvetica","Arial","sans-serif"',
      headers_font_family: '"Sofia","Helvetica","Helvetica","Arial","sans-serif"',
    },
  });